/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React, { useEffect } from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Footer } from './footer';
import Header from './header';
import GlobalStyles from '../styles/global';
import { analytics } from '../utils/analytics';

export const Page = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 98vh;
  max-width: 37rem;
  margin: 0 auto;
`;

export const Body = styled.div`
  flex: 1;
  max-width: 960px;
  padding-top: 0;
`;

const Layout = ({ children }) => {
  const data = useStaticQuery(graphql`
    query LayoutSiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `);

  useEffect(() => {
    analytics.trackVisit();
  }, []);

  return (
    <>
      <GlobalStyles />
      <Page>
        <Header siteTitle={data.site.siteMetadata.title} />
        <Body>{children}</Body>
        <Footer />
      </Page>
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
